"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var react_1 = require("react");
var CurrencyContext_1 = require("../../../common/context/CurrencyContext");
var react_intl_1 = require("react-intl");
var FinanceDetailsRows_1 = require("../../../../common/enum/FinanceDetailsRows");
var useFinanceSummary = function (finance) {
    var intl = react_intl_1.useIntl();
    var _a = usePlatformConfig_1.default().platformConfig.priceDisplay, secondary = _a.secondary, primary = _a.primary;
    var breakdownBlocks = finance.breakdownBlocks;
    var isChangeCurrency = react_1.useContext(CurrencyContext_1.default).isChangeCurrency;
    var currency = isChangeCurrency ? secondary.currency : primary.currency;
    var breakdown = breakdownBlocks.find(function (row) { return row.currency === currency; });
    var financeBreakdownBlocks = breakdown.blocks.find(function (row) { return row.length !== 0; });
    return financeBreakdownBlocks.map(function (row) {
        var key = row.key, value = row.value;
        switch (key) {
            case FinanceDetailsRows_1.FinanceDetailsRows.LOAN_TERM_PERIOD:
                return __assign(__assign({}, row), { value: value + " " + intl.formatMessage({
                        id: 'trans__checkout__next_step__summary_on_the_right__months_label',
                    }), shouldDisplayDivider: true });
            case FinanceDetailsRows_1.FinanceDetailsRows.REPAYMENT:
                return __assign(__assign({}, row), { shouldDisplayDivider: true });
        }
        return row;
    });
};
exports.default = useFinanceSummary;
